export default __webpack_public_path__ + "static/media/Modelo 5.5dac7e49.png";